<lyceo-content [background]="true" [alternate]="true">
  <lyceo-single-card-layout>
    <h3 class="mb-3">Login server is niet bereikbaar</h3>
    <p class="mb-2">
      Klik op de knop hieronder om het opnieuw te proberen. Als dit ook niet
      werkt probeer het dan op een later moment nog eens.
    </p>
    <button
      lyceoButton
      data-testid="reload-button"
      [block]="true"
      (click)="reload()"
    >
      Opnieuw proberen
    </button>
  </lyceo-single-card-layout>
</lyceo-content>
